import { CreateIssueResult, Project } from '@qality/common-model';
import {
  ProjectService,
  StorageOfUniqueServices,
} from '@qality/common-service';
import Utils from '@qality/common-utils/src/Utils';

export default {
  async createTestCaseDialog(project: Project): Promise<CreateIssueResult> {
    const usedProject = Utils.isNilOrEmpty(project)
      ? await ProjectService.getAnyProjectWithConfiguredQAlity()
      : project;

    return StorageOfUniqueServices.get('FlagCreator').showCreateIssueDialog(
      '',
      usedProject.getQAlityTestId(),
      usedProject.id
    );
  },
};
